// src/components/Admin/Reusable/LocaleTabs.jsx
import React from "react";
import { Box } from "@mui/material";

export function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`locale-tabpanel-${index}`}
      aria-labelledby={`locale-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

export const a11yProps = (index) => ({
  id: `locale-tab-${index}`,
  "aria-controls": `locale-tabpanel-${index}`,
});
